import type { FC, PropsWithChildren } from 'react';
import { cloneElement, isValidElement } from 'react';

type Props = {
    size: number;
} & PropsWithChildren;

export const ButtonIconWrapper: FC<Props> = ({ size, children }) => {
    if (isValidElement(children)) {
        return cloneElement(children, {
            size
        } as Record<string, string | number>);
    }

    return children;
};
